import styled from 'styled-components';

export const FullDisplayContainer = styled.div`
  overflow: scroll;
  width: auto;
  margin-bottom: ${props => props && props.theme && props.theme.spacing(1)}px;
`;
